/** Fetch /storage/* URLs with JWT (browser img/a tags cannot send Authorization). */

const blobUrlCache = new Map<string, string>();

export function revokeAuthenticatedStorageCache(): void {
  for (const url of blobUrlCache.values()) {
    URL.revokeObjectURL(url);
  }
  blobUrlCache.clear();
}

export async function fetchAuthenticatedStorage(url: string): Promise<Blob> {
  const token = localStorage.getItem('auth_token');
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    throw new Error(`Storage fetch failed: ${res.status}`);
  }
  return res.blob();
}

export async function getAuthenticatedBlobUrl(url: string): Promise<string> {
  const cached = blobUrlCache.get(url);
  if (cached) return cached;
  const blob = await fetchAuthenticatedStorage(url);
  const objectUrl = URL.createObjectURL(blob);
  blobUrlCache.set(url, objectUrl);
  return objectUrl;
}

export async function downloadAuthenticatedFile(url: string, filename: string): Promise<void> {
  const blob = await fetchAuthenticatedStorage(url);
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}
